<template>
  <div class="check-out-approval">
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
        size="small"
      ></el-input>
    </template>
    <el-date-picker
      v-model="search.date"
      type="daterange"
      :clearable="false"
      range-separator="-"
      :start-placeholder="$t('app.checkOutStartTime')"
      :end-placeholder="$t('app.checkOutEndTime')"
      size="small"
      style="margin-right: 10px"
    >
    </el-date-picker>
    <el-button type="primary" @click="reset" size="small">{{
      $t("app.reset")
    }}</el-button>
    <el-button
      type="success"
      @click="getList"
      icon="el-icon-search"
      size="small"
      >{{ $t("app.search") }}</el-button
    >
    <div class="table-container">
      <el-table
        :data="tableData"
        height="620"
        style="width: 100%; color: black"
        @sort-change="sortChange"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="left" class="demo-table-expand">
              <el-form-item label="延遲退宿原因">
                <span>{{ scope.row.reason }}</span>
              </el-form-item>
              <el-form-item label="證明文件">
                <br />
                <div
                  v-for="i in scope.row.doc"
                  :key="i.Name"
                  style="text-indent: 4ex"
                >
                  <el-link
                    @click="download(i)"
                    target="_blank"
                    style="text-indent: 0ex"
                  >
                    {{ i.Name }}
                  </el-link>
                </div>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120px"
          :label="$t('app.operation')"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              :disabled="scope.row.auditStatus !== '0'"
              type="success"
              @click="confirm(scope.row)"
            >
              {{
                scope.row.auditStatus === "0"
                  ? $t("app.confirmS")
                  : scope.row.auditStatus === "1"
                  ? $t("app.hasConfirm")
                  : $t("app.hasCheckout")
              }}</el-button
            >
          </template>
        </el-table-column>
        <template v-for="col in column">
          <el-table-column
            v-if="
              col.model === 'room' ||
              col.model === 'date' ||
              col.model === 'studentNumber'
            "
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
            sortable="custom"
          ></el-table-column>
          <el-table-column
            v-else
            :key="col.model"
            align="center"
            :label="col.label"
            :prop="col.model"
          >
            <template slot-scope="scope">
              <template v-if="col.model == 'date' && scope.row['isExpiring']">
                <div style="color: red; font-weight: bolder">
                  {{ scope.row[col.model] }}
                </div>
              </template>
              <template v-else>
                {{ scope.row[col.model] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getList, confirm } from "@/api/dormitoryManagement/approval";
import { delEmpty, downloadFileByBlob } from "@/utils/utils";
import { download } from "@/api/download";
export default {
  components: {},
  data() {
    return {
      url: "/CheckOutManagement/DownloadFile",
      auto: false,
      time: "",
      loading: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
        { model: "room", label: this.$t("app.roomCode") },
      ],
      column: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "otherName", label: this.$t("app.otherName") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        {
          model: "contactInformation",
          label: this.$t("app.contactInformation"),
        },
        {
          model: "room",
          label: this.$t("app.roomCode"),
        },
        {
          model: "date",
          label: this.$t("app.checkOutTime"),
        },
      ],
      search: {
        room: "",
        studentNumber: "",
        name: "",
        date: [],
        orderKey: "",
        orderType: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    confirm(row) {
      this.$confirm('是否確認"' + row.nameChina + '"的退宿申請？').then(() => {
        confirm({
          StudentCode: row.studentNumber,
          CheckOutDate: row.date,
        }).then(() => {
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
          this.getList();
        });
        this.getList();
      });
    },
    download(item) {
      download(this.url, { rawFileName: item.Url }).then((content) => {
        var blobContent = new Blob([content]);
        downloadFileByBlob(blobContent, item.Name);
      });
    },
    getList() {
      getList(
        delEmpty({
          RoomIndex: this.search.room,
          Name: this.search.name,
          StudentCode: this.search.studentNumber,
          ExpectedCheckOutStartTime: this.search.date[0] || "",
          ExpectedCheckOutEndTime: this.search.date[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size,
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
        })
      ).then((res) => {
        this.total = res.data.Total;
        if (this.total === 0 || this.total === undefined) {
          this.tableData = null;
          return;
        }
        this.tableData = res.data.Items.map((item) => {
          return {
            studentNumber: item.StudentCode,
            nameEnglish: item.EnglishName,
            nameChina: item.ChineseName,
            contactInformation: item.ContactMobile,
            room: item.RoomIndex,
            date: item.ExpectedCheckOutTime,
            reason: item.ReasonForLateCheckOut,
            docCode: item.AttachmentCode,
            doc: item.AttachmentGroup,
            auditStatus: item.AuditStatus,
            otherName: item.OtherName,
            isExpiring: item.IsExpiring,
          };
        });
      });
    },
    reset() {
      this.search.room = "";
      this.search.studentNumber = "";
      this.search.name = "";
      this.search.date = [];
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    tableRowClassName({ row }) {
      if (row.isExpiring) {
        return "checkout-approval-warning-row";
      } else {
        return "";
      }
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.check-out-approval {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  height: calc(100% - 100px);
  .table-container {
    height: calc(100% - 150px);
    overflow: auto;
  }
}
</style>
<style>
.el-table .checkout-approval-warning-row {
  background-color: #ffcc00;
}
</style>
